// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const PlayFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M77.285 48.384a6.935 6.935 0 0 1-3.58 6.006L29.17 79.113a7.096 7.096 0 0 1-6.959-.05 6.934 6.934 0 0 1-3.495-5.995V22.932a6.933 6.933 0 0 1 3.53-6.017 7.108 7.108 0 0 1 6.997.012L73.777 42.34a6.928 6.928 0 0 1 3.508 6.044Z"
			fill="#fff"
			fillRule="evenodd"
		/>
	</svg>
);
export default PlayFilled;
